import 'swiper/css';
import 'swiper/css/navigation';

import { useRef } from 'react';
import classNames from 'classnames';
import { AutoTestCardIcon, DtmVirtualCardIcon, SwiperArrowLeftIcon, SwiperArrowRightIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { getAppLink, globalConst } from 'modules/global';

const TestsCategoryCard = () => {
  const t = useTranslations('home.banner');
  const link = getAppLink();

  const prevRef = useRef<HTMLButtonElement | null>(null);
  const nextRef = useRef<HTMLButtonElement | null>(null);

  const autoTestTitle = t('AvtoTest');

  const cards = [
    {
      title: t('XususiyOliygohlar'),
      bg: 'bg-indigo-600',
      icon: (
        <div className="relative flex justify-center">
          <div className="h-30 absolute z-10 mt-8 w-48 rounded-md bg-gray-100 shadow-md" />
          <div
            className="h-38 w-50 z-10 bg-[url('/images/private-university-card.webp')] bg-cover bg-center"
            title="Private University Card"
          />
        </div>
      ),
      textColor: 'text-white',
      url: globalConst.pageNames.PRIVATE_UNIVERSITIES
    },
    {
      title: 'Akam Battle',
      bg: 'bg-green-500',
      icon: (
        <div className="relative flex justify-center">
          <div className="size-70 z-1 absolute -top-20 bg-[url('/images/akam-battle-bg.webp')] bg-cover bg-center" />
          <div className="size-45 z-10 bg-[url('/images/akam-battle.webp')] bg-cover bg-center" title="Virtual test" />
        </div>
      ),
      url: link,
      isExternalLink: true,
      textColor: 'text-white'
    },

    {
      title: t('DTMtest'),
      bg: 'bg-teal-300',
      icon: <DtmVirtualCardIcon />,
      url: globalConst.pageNames.DTM
    },
    {
      title: t('PrezidentSchool'),
      bg: 'bg-teal-600',
      icon: (
        <div
          className="h-37 w-50 bg-[url('/images/prezident-card-icon.webp')] bg-cover bg-center"
          title="Prezident school"
        />
      ),
      textColor: 'text-white',
      url: `${globalConst.pageNames.TOPIC_TEST}/prezident-maktabi`
    },
    {
      title: autoTestTitle,
      bg: 'bg-yellow-300',
      pr0: true,
      icon: (
        <div className="relative mt-8 flex justify-end rounded-xl">
          <div className="w-50 absolute -top-6 right-0 z-10">
            <div
              className="h-50 w-55 bg-[url('/images/Rectangle-avto-test.webp')] bg-cover bg-center"
              title="Prezident school"
            />

            {/* <Image
              loading="eager"
              title="Avto test"
              priority
              src="/images/Rectangle-avto-test.webp"
              alt="Rectangle Avto test"
              width={300}
              height={300}
            /> */}
          </div>
          <div className="relative z-20">
            <AutoTestCardIcon />
          </div>
        </div>
      ),
      url: `${globalConst.pageNames.TOPIC_TEST}/avto-test`
    },
    {
      title: t('Virtualtest'),
      bg: 'bg-red-200',
      icon: <div className="h-45 w-60 bg-[url('/images/vertual-bg.webp')] bg-cover bg-center" title="Virtual test" />,
      url: globalConst.pageNames.VIRTUAL
    }
  ];

  return (
    <div className="relative mx-auto my-10 max-w-screen">
      <button
        ref={prevRef}
        aria-label="Previous slide"
        className="absolute -left-5 top-1/2 z-30 -translate-y-1/2 cursor-pointer rounded-full bg-white p-2 shadow-md"
      >
        <SwiperArrowLeftIcon />
      </button>
      <button
        ref={nextRef}
        aria-label="Next slide"
        className="absolute -right-5 top-1/2 z-30 -translate-y-1/2 cursor-pointer rounded-full bg-white p-2 shadow-md"
      >
        <SwiperArrowRightIcon />
      </button>

      <Swiper
        modules={[Navigation, FreeMode]}
        loop={true}
        freeMode
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current
        }}
        onInit={swiper => {
          if (swiper.params.navigation) {
            const nav = swiper.params.navigation as any;

            nav.prevEl = prevRef.current;
            nav.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }
        }}
        spaceBetween={12}
        slidesPerView={4}
        width={1042}
      >
        {cards.map((card, index) => {
          const isAutoTest = card.title === autoTestTitle;

          return (
            // eslint-disable-next-line react/no-array-index-key
            <SwiperSlide key={index} className="m-3 min-w-59 max-w-59 ">
              <Link href={card.url} target={card?.isExternalLink ? '_blank' : undefined}>
                <div
                  className={classNames(
                    'min-h-70 max-h-70 max-w-61 min-w-61 relative w-full overflow-hidden rounded-xl p-3 pb-0 transition-transform duration-200 hover:scale-105',
                    card.bg,
                    { 'pr-0': card.pr0 }
                  )}
                >
                  <div
                    className={classNames('mt-3 text-center text-lg font-medium', card.textColor, {
                      'text-gray-800': !card.textColor
                    })}
                  >
                    {card.title}
                  </div>
                  <div className={classNames('mt-8 flex justify-center', { 'justify-end': isAutoTest })}>
                    {card.icon}
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default TestsCategoryCard;
